import "tippy.js/dist/tippy.css";
import React from "react";
import Tippy from "@tippyjs/react";
import PropTypes from "prop-types";
import ControlButton from "./ControlButton";
import { SettingsMenu } from "./settingsButton/SettingsMenu";
import styles from "./settingsButton/SettingsMenu.css";

export const SettingsButton = ({ visible, ...props }) => {
  return (
    <Tippy
      appendTo={document.querySelector(".verse")}
      content={<SettingsMenu />}
      interactive
      trigger={visible ? undefined : "mouseenter click focus"}
      visible={visible || undefined}
      className={styles.tippy}
    >
      <ControlButton
        ariaLabel="Playback Settings"
        border={false}
        className={styles.button}
        classNameModifiers={["icon"]}
        {...props}
      >
        <span className="icon-Settings" />
      </ControlButton>
    </Tippy>
  );
};

SettingsButton.propTypes = {
  /**
   * Indicates the menu should be forced to be open
   *
   * This is only useful for styling work
   */
  visible: PropTypes.bool,
};
